import React from 'react'
import { GalleryLoader } from '../../../utils/import.gallery';

import closeBtn from './../../../UI/general/close.svg'

interface Props{
    isMultimediaOpened: boolean,
    selectedBike: any,
    handleOpenMultimedia: any,
    handleOpenImage: any
}

interface State{}

class GalleryBar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    handleGenerateThumbs = () => {
        if(GalleryLoader[this.props.selectedBike.Nombre] !== undefined){
            return(
                GalleryLoader[this.props.selectedBike.Nombre]().map((data: any, index: number) => 
                    <div className='gallery-individual-container' key={index} onClick = {() => {this.props.handleOpenImage(true,index)}}>
                        <img  src={data.default}/>
                    </div>
                )
            )
        }
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isMultimediaOpened ? "gallery-bar fade-in":"gallery-bar fade-out"}>
                <div className='gallery-bar-header'>
                    <div className='gallery-bar-title'>
                        MULTIMEDIA
                    </div>
                    <img className='close-btn-gallery' src={closeBtn} onClick = {() => {this.props.handleOpenMultimedia(false)}}/>
                </div>
                <div className='gallery-hr'/>
                <div className='gallery-thumb-container'>
                    {
                        this.handleGenerateThumbs()
                    }
                </div>
            </div>
        )
    }
}

export default GalleryBar